import { HttpParams } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export enum ChartActionTypes {
    GET_COUNT_DONE_LILATES = '[CHART] Obtenir le compte des Lilates terminés',
    GET_COUNT_DONE_LILATES_SUCCESS = '[CHART] Obtenir le compte des Lilates terminés avec succès',
    GET_COUNT_DONE_LILATES_FAILURE = '[CHART] Échec de l\'obtention du compte des Lilates terminés',

    GET_COUNT_DONE_LILATES_BY_START = '[CHART] Obtenir le compte des Lilates terminés par date de passage',
    GET_COUNT_DONE_LILATES_BY_START_SUCCESS = '[CHART] Obtenir le compte des Lilates terminés avec succès par date de passage',
    GET_COUNT_DONE_LILATES_BY_START_FAILURE = '[CHART] Échec de l\'obtention du compte des Lilates terminés par date de passage',

    GET_COUNT_CREATED_LILATES = '[CHART] Obtenir le compte des Lilates créés',
    GET_COUNT_CREATED_LILATES_SUCCESS = '[CHART] Obtenir le compte des Lilates créés avec succès',
    GET_COUNT_CREATED_LILATES_FAILURE = '[CHART] Échec de l\'obtention du compte des Lilates créés',

    GET_COUNT_MONTHLY_CREATED_LILATES = '[CHART] Obtenir le compte des Lilates créés mensuellement',
    GET_COUNT_MONTHLY_CREATED_LILATES_SUCCESS = '[CHART] Obtenir le compte des Lilates créés mensuellement avec succès',
    GET_COUNT_MONTHLY_CREATED_LILATES_FAILURE = '[CHART] Échec de l\'obtention du compte des Lilates créés mensuellement',

    GET_TAUX_PASSAGE_LILATES = '[CHART] Obtenir le taux de passage des Lilates',
    GET_TAUX_PASSAGE_LILATES_SUCCESS = '[CHART] Obtenir le taux de passage des Lilates avec succès',
    GET_TAUX_PASSAGE_LILATES_FAILURE = '[CHART] Échec de l\'obtention du taux de passage des Lilates',

    GET_SUCCESS_LILATES = '[CHART] Obtenir le taux de réussite des Lilates',
    GET_SUCCESS_LILATES_SUCCESS = '[CHART] Obtenir le taux de réussite des Lilates avec succès',
    GET_SUCCESS_LILATES_FAILURE = '[CHART] Échec de l\'obtention du taux de réussite des Lilates',

    GET_EVOLUTION_DONE_LILATES = '[CHART] Obtenir l\'évolution des Lilates terminés',
    GET_EVOLUTION_DONE_LILATES_SUCCESS = '[CHART] Obtenir l\'évolution des Lilates terminés avec succès',
    GET_EVOLUTION_DONE_LILATES_FAILURE = '[CHART] Échec de l\'obtention de l\'évolution des Lilates terminés',

    GET_EVOLUTION_DONE_LILATES_BY_START = '[CHART] Obtenir l\'évolution des Lilates terminés par date de passage',
    GET_EVOLUTION_DONE_LILATES_BY_START_SUCCESS = '[CHART] Obtenir l\'évolution des Lilates terminés avec succès par date de passage',
    GET_EVOLUTION_DONE_LILATES_BY_START_FAILURE = '[CHART] Échec de l\'obtention de l\'évolution des Lilates terminés par date de passage',

    GET_EVOLUTION_CREATED_LILATES = '[CHART] Obtenir l\'évolution des Lilates créés',
    GET_EVOLUTION_CREATED_LILATES_SUCCESS = '[CHART] Obtenir l\'évolution des Lilates créés avec succès',
    GET_EVOLUTION_CREATED_LILATES_FAILURE = '[CHART] Échec de l\'obtention de l\'évolution des Lilates créés',

    GET_EVOLUTION_MONTHLY_CREATED_LILATES = '[CHART] Obtenir l\'évolution des Lilates créés mensuellement',
    GET_EVOLUTION_MONTHLY_CREATED_LILATES_SUCCESS = '[CHART] Obtenir l\'évolution des Lilates créés mensuellement avec succès',
    GET_EVOLUTION_MONTHLY_CREATED_LILATES_FAILURE = '[CHART] Échec de l\'obtention de l\'évolution des Lilates créés mensuellement',

    GET_EVOLUTION_TAUX_PASSAGE_LILATES = '[CHART] Obtenir l\'évolution du taux de passage des Lilates',
    GET_EVOLUTION_TAUX_PASSAGE_LILATES_SUCCESS = '[CHART] Obtenir l\'évolution du taux de passage des Lilates avec succès',
    GET_EVOLUTION_TAUX_PASSAGE_LILATES_FAILURE = '[CHART] Échec de l\'obtention de l\'évolution du taux de passage des Lilates',

    GET_EVOLUTION_SUCCESS_LILATES = '[CHART] Obtenir l\'évolution du taux de réussite des Lilates',
    GET_EVOLUTION_SUCCESS_LILATES_SUCCESS = '[CHART] Obtenir l\'évolution du taux de réussite des Lilates avec succès',
    GET_EVOLUTION_SUCCESS_LILATES_FAILURE = '[CHART] Échec de l\'obtention de l\'évolution du taux de réussite des Lilates',

    GET_CHECK_DATA_BY_YEAR_LILATES = '[CHART] Obtenir les données de vérification par année des Lilates',
    GET_CHECK_DATA_BY_YEAR_LILATES_SUCCESS = '[CHART] Obtenir les données de vérification par année des Lilates avec succès',
    GET_CHECK_DATA_BY_YEAR_LILATES_FAILURE = '[CHART] Échec de l\'obtention des données de vérification par année des Lilates',

    GET_LANGUAGES_LILATES = '[CHART] Obtenir les langues des Lilates',
    GET_LANGUAGES_LILATES_SUCCESS = '[CHART] Obtenir les langues des Lilates avec succès',
    GET_LANGUAGES_LILATES_FAILURE = '[CHART] Échec de l\'obtention des langues des Lilates',

    GET_TAUX_PASSAGE_LILATES_PER_LANGUES = '[CHART] Obtenir le taux de passage des Lilates par langues',
    GET_TAUX_PASSAGE_LILATES_PER_LANGUES_SUCCESS = '[CHART] Obtenir le taux de passage des Lilates par langues avec succès',
    GET_TAUX_PASSAGE_LILATES_PER_LANGUES_FAILURE = '[CHART] Échec de l\'obtention du taux de passage des Lilates par langues',

    GET_SUCCESS_LILATES_PER_LANGUES = '[CHART] Obtenir le taux de réussite des Lilates par langues',
    GET_SUCCESS_LILATES_PER_LANGUES_SUCCESS = '[CHART] Obtenir le taux de réussite des Lilates par langues avec succès',
    GET_SUCCESS_LILATES_PER_LANGUES_FAILURE = '[CHART] Échec de l\'obtention du taux de réussite des Lilates par langues',

    GET_STATUS_LILATES = '[CHART] Obtenir les statuts des Lilates',
    GET_STATUS_LILATES_SUCCESS = '[CHART] Obtenir les statuts des Lilates avec succès',
    GET_STATUS_LILATES_FAILURE = '[CHART] Échec de l\'obtention des statuts des Lilates',

    GET_LEVEL_LILATES = '[CHART] Obtenir le niveau des Lilates',
    GET_LEVEL_LILATES_SUCCESS = '[CHART] Obtenir le niveau des Lilates avec succès',
    GET_LEVEL_LILATES_FAILURE = '[CHART] Échec de l\'obtention du niveau des Lilates',

    GET_LEVEL_PER_LANGUAGES_LILATES = '[CHART] Obtenir le niveau par langues des Lilates',
    GET_LEVEL_PER_LANGUAGES_LILATES_SUCCESS = '[CHART] Obtenir le niveau par langues des Lilates avec succès',
    GET_LEVEL_PER_LANGUAGES_LILATES_FAILURE = '[CHART] Échec de l\'obtention du niveau par langues des Lilates',

    GET_NPS_LILATES = '[CHART] Obtenir le NPS des Lilates',
    GET_NPS_LILATES_SUCCESS = '[CHART] Obtenir le NPS des Lilates avec succès',
    GET_NPS_LILATES_FAILURE = '[CHART] Échec de l\'obtention du NPS des Lilates',

    GET_CSAT_LILATES = '[CHART] Obtenir le CSAT des Lilates',
    GET_CSAT_LILATES_SUCCESS = '[CHART] Obtenir le CSAT des Lilates avec succès',
    GET_CSAT_LILATES_FAILURE = '[CHART] Échec de l\'obtention du CSAT des Lilates',

    GET_CARBON = '[CHART] Obtenir l\'impact carbon',
    GET_CARBON_SUCCESS = '[CHART] Obtenir l\'impact carbon avec succès',
    GET_CARBON_FAILURE = '[CHART] Échec de l\'obtention de l\'impact carbon',

    GET_MODE_FINANCEMENT = '[CHART] Obtenir les modes de financement des Lilates',
    GET_MODE_FINANCEMENT_SUCCESS = '[CHART] Obtenir les modes de financement des Lilates avec succès',
    GET_MODE_FINANCEMENT_FAILURE = '[CHART] Échec de l\'obtention des modes de financement des Lilates',

    GET_GENDER_LILATES = '[CHART] Obtenir la répartition des Lilates par genre',
    GET_GENDER_LILATES_SUCCESS = '[CHART] Obtenir la répartition des Lilates par genre avec succès',
    GET_GENDER_LILATES_FAILURE = '[CHART] Échec de l\'obtention de la répartition des Lilates par genre',

    GET_JOB_SITUATION_LILATES = '[CHART] Obtenir la répartition des Lilates par situation professionnelle',
    GET_JOB_SITUATION_LILATES_SUCCESS = '[CHART] Obtenir la répartition des Lilates par situation professionnelle avec succès',
    GET_JOB_SITUATION_LILATES_FAILURE = '[CHART] Échec de l\'obtention de la répartition des Lilates par situation professionnelle',

    GET_JOB_LILATES = '[CHART] Obtenir la répartition des Lilates par métier',
    GET_JOB_LILATES_SUCCESS = '[CHART] Obtenir la répartition des Lilates par métier avec succès',
    GET_JOB_LILATES_FAILURE = '[CHART] Échec de l\'obtention de la répartition des Lilates par métier',

    GET_BUSINESS_LILATES = '[CHART] Obtenir la répartition des Lilates par secteur d\'activité',
    GET_BUSINESS_LILATES_SUCCESS = '[CHART] Obtenir la répartition des Lilates par secteur d\'activité avec succès',
    GET_BUSINESS_LILATES_FAILURE = '[CHART] Échec de l\'obtention de la répartition des Lilates par secteur d\'activité',

    GET_IN_TRAINING_LILATES = '[CHART] Obtenir la répartition des Lilates par statut de formation',
    GET_IN_TRAINING_LILATES_SUCCESS = '[CHART] Obtenir la répartition des Lilates par statut de formation avec succès',
    GET_IN_TRAINING_LILATES_FAILURE = '[CHART] Échec de l\'obtention de la répartition des Lilates par statut de formation',

    GET_IDENTITY_ISSUE_COUNT_LILATES = '[CHART] Obtenir le nombre de Lilates avec un problème d\'identité',
    GET_IDENTITY_ISSUE_COUNT_LILATES_SUCCESS = '[CHART] Obtenir le nombre de Lilates avec un problème d\'identité avec succès',
    GET_IDENTITY_ISSUE_COUNT_LILATES_FAILURE = '[CHART] Échec de l\'obtention du nombre de Lilates avec un problème d\'identité',

    GET_PHOTO_STATUS_REFUSED_COUNT_LILATES = '[CHART] Obtenir le nombre de Lilates avec un statut de photo refusé',
    GET_PHOTO_STATUS_REFUSED_COUNT_LILATES_SUCCESS = '[CHART] Obtenir le nombre de Lilates avec un statut de photo refusé avec succès',
    GET_PHOTO_STATUS_REFUSED_COUNT_LILATES_FAILURE = '[CHART] Échec de l\'obtention du nombre de Lilates avec un statut de photo refusé',

    GET_UNIQUE_COMPANIES_COUNT_LILATES = '[CHART] Obtenir le nombre d\'entreprises uniques dans les Lilates',
    GET_UNIQUE_COMPANIES_COUNT_LILATES_SUCCESS = '[CHART] Obtenir le nombre d\'entreprises uniques dans les Lilates avec succès',
    GET_UNIQUE_COMPANIES_COUNT_LILATES_FAILURE = '[CHART] Échec de l\'obtention du nombre d\'entreprises uniques dans les Lilates',

    GET_AVERAGE_AGE_LILATES = '[CHART] Obtenir l\'âge moyen des étudiants des Lilates',
    GET_AVERAGE_AGE_LILATES_SUCCESS = '[CHART] Obtenir l\'âge moyen des étudiants des Lilates avec succès',
    GET_AVERAGE_AGE_LILATES_FAILURE = '[CHART] Échec de l\'obtention de l\'âge moyen des étudiants des Lilates',

    GET_AGE_RANGE_COUNT_LILATES = '[CHART] Obtenir le décompte des étudiants des Lilates par tranche d\'âge',
    GET_AGE_RANGE_COUNT_LILATES_SUCCESS = '[CHART] Obtenir le décompte des étudiants des Lilates par tranche d\'âge avec succès',
    GET_AGE_RANGE_COUNT_LILATES_FAILURE = '[CHART] Échec de l\'obtention du décompte des étudiants des Lilates par tranche d\'âge',
}

export const GetCountDoneLilates = createAction(
    ChartActionTypes.GET_COUNT_DONE_LILATES,
    props<{ params: HttpParams }>()
);

export const GetCountDoneLilatesSuccess = createAction(
    ChartActionTypes.GET_COUNT_DONE_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetCountDoneLilatesFailure = createAction(
    ChartActionTypes.GET_COUNT_DONE_LILATES_FAILURE
);

export const GetCountDoneLilatesByStart = createAction(
    ChartActionTypes.GET_COUNT_DONE_LILATES_BY_START,
    props<{ params: HttpParams }>()
);

export const GetCountDoneLilatesByStartSuccess = createAction(
    ChartActionTypes.GET_COUNT_DONE_LILATES_BY_START_SUCCESS,
    props<{ data: any }>()
);

export const GetCountDoneLilatesByStartFailure = createAction(
    ChartActionTypes.GET_COUNT_DONE_LILATES_BY_START_FAILURE
);

export const GetCountCreatedLilates = createAction(
    ChartActionTypes.GET_COUNT_CREATED_LILATES,
    props<{ params: HttpParams }>()
);

export const GetCountCreatedLilatesSuccess = createAction(
    ChartActionTypes.GET_COUNT_CREATED_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetCountCreatedLilatesFailure = createAction(
    ChartActionTypes.GET_COUNT_CREATED_LILATES_FAILURE
);

export const GetCountMonthlyCreatedLilates = createAction(
    ChartActionTypes.GET_COUNT_MONTHLY_CREATED_LILATES,
    props<{ params: HttpParams }>()
);

export const GetCountMonthlyCreatedLilatesSuccess = createAction(
    ChartActionTypes.GET_COUNT_MONTHLY_CREATED_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetCountMonthlyCreatedLilatesFailure = createAction(
    ChartActionTypes.GET_COUNT_MONTHLY_CREATED_LILATES_FAILURE
);

export const GetEvolutionMonthlyCreatedLilates = createAction(
    ChartActionTypes.GET_EVOLUTION_MONTHLY_CREATED_LILATES,
    props<{ params: HttpParams }>()
);

export const GetEvolutionMonthlyCreatedLilatesSuccess = createAction(
    ChartActionTypes.GET_EVOLUTION_MONTHLY_CREATED_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetEvolutionMonthlyCreatedLilatesFailure = createAction(
    ChartActionTypes.GET_EVOLUTION_MONTHLY_CREATED_LILATES_FAILURE
);

export const GetCheckDataByYearLilates = createAction(
    ChartActionTypes.GET_CHECK_DATA_BY_YEAR_LILATES,
);

export const GetCheckDataByYearLilatesSuccess = createAction(
    ChartActionTypes.GET_CHECK_DATA_BY_YEAR_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetCheckDataByYearLilatesFailure = createAction(
    ChartActionTypes.GET_CHECK_DATA_BY_YEAR_LILATES_FAILURE
);

export const GetLanguagesLilates = createAction(
    ChartActionTypes.GET_LANGUAGES_LILATES,
    props<{ params: HttpParams }>()
);

export const GetLanguagesLilatesSuccess = createAction(
    ChartActionTypes.GET_LANGUAGES_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetLanguagesLilatesFailure = createAction(
    ChartActionTypes.GET_LANGUAGES_LILATES_FAILURE
);

export const GetTauxPassageLilates = createAction(
    ChartActionTypes.GET_TAUX_PASSAGE_LILATES,
    props<{ params: HttpParams }>()
);

export const GetTauxPassageLilatesSuccess = createAction(
    ChartActionTypes.GET_TAUX_PASSAGE_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetTauxPassageLilatesFailure = createAction(
    ChartActionTypes.GET_TAUX_PASSAGE_LILATES_FAILURE
);

export const GetSuccessLilates = createAction(
    ChartActionTypes.GET_SUCCESS_LILATES,
    props<{ params: HttpParams }>()
);

export const GetSuccessLilatesSuccess = createAction(
    ChartActionTypes.GET_SUCCESS_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetSuccessLilatesFailure = createAction(
    ChartActionTypes.GET_SUCCESS_LILATES_FAILURE
);

export const GetStatusLilates = createAction(
    ChartActionTypes.GET_STATUS_LILATES,
    props<{ params: HttpParams }>()
);

export const GetStatusLilatesSuccess = createAction(
    ChartActionTypes.GET_STATUS_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetStatusLilatesFailure = createAction(
    ChartActionTypes.GET_STATUS_LILATES_FAILURE
);

export const GetTauxPassageLilatesPerLangues = createAction(
    ChartActionTypes.GET_TAUX_PASSAGE_LILATES_PER_LANGUES,
    props<{ params: HttpParams }>()
);

export const GetTauxPassageLilatesPerLanguesSuccess = createAction(
    ChartActionTypes.GET_TAUX_PASSAGE_LILATES_PER_LANGUES_SUCCESS,
    props<{ data: any }>()
);

export const GetTauxPassageLilatesPerLanguesFailure = createAction(
    ChartActionTypes.GET_TAUX_PASSAGE_LILATES_PER_LANGUES_FAILURE
);

export const GetSuccessLilatesPerLangues = createAction(
    ChartActionTypes.GET_SUCCESS_LILATES_PER_LANGUES,
    props<{ params: HttpParams }>()
);

export const GetSuccessLilatesPerLanguesSuccess = createAction(
    ChartActionTypes.GET_SUCCESS_LILATES_PER_LANGUES_SUCCESS,
    props<{ data: any }>()
);

export const GetSuccessLilatesPerLanguesFailure = createAction(
    ChartActionTypes.GET_SUCCESS_LILATES_PER_LANGUES_FAILURE
);

export const GetLevelLilates = createAction(
    ChartActionTypes.GET_LEVEL_LILATES,
    props<{ params: HttpParams }>()
);

export const GetLevelLilatesSuccess = createAction(
    ChartActionTypes.GET_LEVEL_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetLevelLilatesFailure = createAction(
    ChartActionTypes.GET_LEVEL_LILATES_FAILURE
);

export const GetLevelPerLanguagesLilates = createAction(
    ChartActionTypes.GET_LEVEL_PER_LANGUAGES_LILATES,
    props<{ params: HttpParams }>()
);

export const GetLevelPerLanguagesLilatesSuccess = createAction(
    ChartActionTypes.GET_LEVEL_PER_LANGUAGES_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetLevelPerLanguagesLilatesFailure = createAction(
    ChartActionTypes.GET_LEVEL_PER_LANGUAGES_LILATES_FAILURE
);

export const GetNpsLilates = createAction(
    ChartActionTypes.GET_NPS_LILATES,
    props<{ params: HttpParams }>()
);

export const GetNpsLilatesSuccess = createAction(
    ChartActionTypes.GET_NPS_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetNpsLilatesFailure = createAction(
    ChartActionTypes.GET_NPS_LILATES_FAILURE
);

export const GetCsatLilates = createAction(
    ChartActionTypes.GET_CSAT_LILATES,
    props<{ params: HttpParams }>()
);

export const GetCsatLilatesSuccess = createAction(
    ChartActionTypes.GET_CSAT_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetCsatLilatesFailure = createAction(
    ChartActionTypes.GET_CSAT_LILATES_FAILURE
);

export const GetCarbon = createAction(
    ChartActionTypes.GET_CARBON,
    props<{ params: HttpParams }>()
);

export const GetCarbonSuccess = createAction(
    ChartActionTypes.GET_CARBON_SUCCESS,
    props<{ data: any }>()
);

export const GetCarbonFailure = createAction(
    ChartActionTypes.GET_CARBON_FAILURE
);

export const GetModeFinancement = createAction(
    ChartActionTypes.GET_MODE_FINANCEMENT,
    props<{ params: HttpParams }>()
);

export const GetModeFinancementSuccess = createAction(
    ChartActionTypes.GET_MODE_FINANCEMENT_SUCCESS,
    props<{ data: any }>()
);

export const GetModeFinancementFailure = createAction(
    ChartActionTypes.GET_MODE_FINANCEMENT_FAILURE
);

export const GetGenderLilates = createAction(
    ChartActionTypes.GET_GENDER_LILATES,
    props<{ params: HttpParams }>()
);

export const GetGenderLilatesSuccess = createAction(
    ChartActionTypes.GET_GENDER_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetGenderLilatesFailure = createAction(
    ChartActionTypes.GET_GENDER_LILATES_FAILURE
);

export const GetJobSituationLilates = createAction(
    ChartActionTypes.GET_JOB_SITUATION_LILATES,
    props<{ params: HttpParams }>()
);

export const GetJobSituationLilatesSuccess = createAction(
    ChartActionTypes.GET_JOB_SITUATION_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetJobSituationLilatesFailure = createAction(
    ChartActionTypes.GET_JOB_SITUATION_LILATES_FAILURE
);

export const GetJobLilates = createAction(
    ChartActionTypes.GET_JOB_LILATES,
    props<{ params: HttpParams }>()
);

export const GetJobLilatesSuccess = createAction(
    ChartActionTypes.GET_JOB_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetJobLilatesFailure = createAction(
    ChartActionTypes.GET_JOB_LILATES_FAILURE
);

export const GetBusinessLilates = createAction(
    ChartActionTypes.GET_BUSINESS_LILATES,
    props<{ params: HttpParams }>()
);

export const GetBusinessLilatesSuccess = createAction(
    ChartActionTypes.GET_BUSINESS_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetBusinessLilatesFailure = createAction(
    ChartActionTypes.GET_BUSINESS_LILATES_FAILURE
);

export const GetInTrainingLilates = createAction(
    ChartActionTypes.GET_IN_TRAINING_LILATES,
    props<{ params: HttpParams }>()
);

export const GetInTrainingLilatesSuccess = createAction(
    ChartActionTypes.GET_IN_TRAINING_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetInTrainingLilatesFailure = createAction(
    ChartActionTypes.GET_IN_TRAINING_LILATES_FAILURE
);

export const GetIdentityIssueCountLilates = createAction(
    ChartActionTypes.GET_IDENTITY_ISSUE_COUNT_LILATES,
    props<{ params: HttpParams }>()
);

export const GetIdentityIssueCountLilatesSuccess = createAction(
    ChartActionTypes.GET_IDENTITY_ISSUE_COUNT_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetIdentityIssueCountLilatesFailure = createAction(
    ChartActionTypes.GET_IDENTITY_ISSUE_COUNT_LILATES_FAILURE
);

export const GetPhotoStatusRefusedCountLilates = createAction(
    ChartActionTypes.GET_PHOTO_STATUS_REFUSED_COUNT_LILATES,
    props<{ params: HttpParams }>()
);

export const GetPhotoStatusRefusedCountLilatesSuccess = createAction(
    ChartActionTypes.GET_PHOTO_STATUS_REFUSED_COUNT_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetPhotoStatusRefusedCountLilatesFailure = createAction(
    ChartActionTypes.GET_PHOTO_STATUS_REFUSED_COUNT_LILATES_FAILURE
);

export const GetUniqueCompaniesCountLilates = createAction(
    ChartActionTypes.GET_UNIQUE_COMPANIES_COUNT_LILATES,
    props<{ params: HttpParams }>()
);

export const GetUniqueCompaniesCountLilatesSuccess = createAction(
    ChartActionTypes.GET_UNIQUE_COMPANIES_COUNT_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetUniqueCompaniesCountLilatesFailure = createAction(
    ChartActionTypes.GET_UNIQUE_COMPANIES_COUNT_LILATES_FAILURE
);

export const GetAverageAgeLilates = createAction(
    ChartActionTypes.GET_AVERAGE_AGE_LILATES,
    props<{ params: HttpParams }>()
);

export const GetAverageAgeLilatesSuccess = createAction(
    ChartActionTypes.GET_AVERAGE_AGE_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetAverageAgeLilatesFailure = createAction(
    ChartActionTypes.GET_AVERAGE_AGE_LILATES_FAILURE
);

export const GetAgeRangeCountLilates = createAction(
    ChartActionTypes.GET_AGE_RANGE_COUNT_LILATES,
    props<{ params: HttpParams }>()
);

export const GetAgeRangeCountLilatesSuccess = createAction(
    ChartActionTypes.GET_AGE_RANGE_COUNT_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetAgeRangeCountLilatesFailure = createAction(
    ChartActionTypes.GET_AGE_RANGE_COUNT_LILATES_FAILURE
);

export const GetEvolutionDoneLilates = createAction(
    ChartActionTypes.GET_EVOLUTION_DONE_LILATES,
    props<{ params: HttpParams }>()
);

export const GetEvolutionDoneLilatesSuccess = createAction(
    ChartActionTypes.GET_EVOLUTION_DONE_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetEvolutionDoneLilatesFailure = createAction(
    ChartActionTypes.GET_EVOLUTION_DONE_LILATES_FAILURE
);

export const GetEvolutionDoneLilatesByStart = createAction(
    ChartActionTypes.GET_EVOLUTION_DONE_LILATES_BY_START,
    props<{ params: HttpParams }>()
);

export const GetEvolutionDoneLilatesByStartSuccess = createAction(
    ChartActionTypes.GET_EVOLUTION_DONE_LILATES_BY_START_SUCCESS,
    props<{ data: any }>()
);

export const GetEvolutionDoneLilatesByStartFailure = createAction(
    ChartActionTypes.GET_EVOLUTION_DONE_LILATES_BY_START_FAILURE
);

export const GetEvolutionCreatedLilates = createAction(
    ChartActionTypes.GET_EVOLUTION_CREATED_LILATES,
    props<{ params: HttpParams }>()
);

export const GetEvolutionCreatedLilatesSuccess = createAction(
    ChartActionTypes.GET_EVOLUTION_CREATED_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetEvolutionCreatedLilatesFailure = createAction(
    ChartActionTypes.GET_EVOLUTION_CREATED_LILATES_FAILURE
);

export const GetEvolutionTauxPassageLilates = createAction(
    ChartActionTypes.GET_EVOLUTION_TAUX_PASSAGE_LILATES,
    props<{ params: HttpParams }>()
);

export const GetEvolutionTauxPassageLilatesSuccess = createAction(
    ChartActionTypes.GET_EVOLUTION_TAUX_PASSAGE_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetEvolutionTauxPassageLilatesFailure = createAction(
    ChartActionTypes.GET_EVOLUTION_TAUX_PASSAGE_LILATES_FAILURE
);

export const GetEvolutionSuccessLilates = createAction(
    ChartActionTypes.GET_EVOLUTION_SUCCESS_LILATES,
    props<{ params: HttpParams }>()
);

export const GetEvolutionSuccessLilatesSuccess = createAction(
    ChartActionTypes.GET_EVOLUTION_SUCCESS_LILATES_SUCCESS,
    props<{ data: any }>()
);

export const GetEvolutionSuccessLilatesFailure = createAction(
    ChartActionTypes.GET_EVOLUTION_SUCCESS_LILATES_FAILURE
);
